import Vue from 'vue';
import Router from 'vue-router';
import { decodeQuery, encodeQuery } from 'beans-admin-plugin';

Vue.use(Router);

export const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/login',
    name: 'login',
    component: require('@/views/login').default
  },
  // {
    // path: '/register',
    // name: 'register',
    // component: require('@/views/register').default
  // },
  {
    path: '/password',
    name: 'password',
    component: require('@/views/password').default
  },
  {
    path: '',
    component: require('@/layouts/nav').default,
    props: {
      menus: require('./menu').default
    },
    children: [
      {
        path: '/home',
        name: 'home',
        meta: {
          can: []
        },
        component: require('@/views/home').default,
      },
      {
        path: '/bind_exists_mini_program',
        name: 'bind_exists_mini_program',
        meta: {
          can: []
        },
        component: require('@/views/bind_wechat/exists_mini_program').default,
      },
      {
        path: '/apply_new_mini_program',
        name: 'apply_new_mini_program',
        meta: {
          can: []
        },
        component: require('@/views/bind_wechat/new_mini_program').default,
      },
      {
        path: '/bind_exists_mini_program/cautions',
        name: 'bind_exists_mini_program.cautions',
        meta: {
          can: []
        },
        component: require('@/views/bind_wechat/cautions').default,
      },
      {
        path: '/mini_program_register',
        name: 'mini_program_register',
        meta: {
          can: 'applications.create'
        },
        component: require('@/views/bind_wechat/register').default,
      },
      {
        path: '/403',
        name: '403',
        component: require('@/views/403').default
      },
      // 以下代码为generator插入代码的标记，请勿修改或删除
      // Generator route
      ...require('@/views/invoice_apply_records').route,
      ...require('@/views/students').route,
      ...require('@/views/reasons').route,
      ...require('@/views/youth_camps').route,
      ...require('@/views/price_type_templates').route,
      ...require('@/views/apply_records').route,
      ...require('@/views/experience_comments').route,
      ...require('@/views/podcasts').route,
      ...require('@/views/book_lists').route,
      ...require('@/views/book_clubs').route,
      ...require('@/views/seek_truth_videos').route,
      ...require('@/views/seek_truth_weeklies').route,
      ...require('@/views/invite_relationships').route,
      ...require('@/views/special_columns').route,
      ...require('@/views/custom_post_lists').route,
      ...require('@/views/articles').route,
      ...require('@/views/hot_words').route,
      ...require('@/views/applications').route,
      ...require('@/views/users').route,
      ...require('@/views/admin_users_roles').route,
      ...require('@/views/roles').route,
      ...require('@/views/operation_records').route,
      ...require('@/views/active_storage/blobs').route,
      ...require('@/views/profile/index').route,
      ...require('@/views/profile/change_password').route,
      ...require('@/views/data_analyses/user_portrait').route,
      ...require('@/views/data_analyses/visit_page').route,
      ...require('@/views/data_analyses/visit_distribution').route,
      ...require('@/views/data_analyses/retain_info').route,
      ...require('@/views/data_analyses/visit_trend').route,
      ...require('@/views/settings').route,
      ...require('@/views/banners').route,
      ...require('@/views/custom_pages').route,
      ...require('@/views/pages').route,
      ...require('@/views/comments').route,
      ...require('@/views/normal_comments').route,
    ]
  },
  {
    path: '*',
    name: '404',
    component: require('./views/404').default
  }
]

const router = new Router({
  mode: 'history',
  base: process.env.VUE_APP_ROUTER_BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  },
  parseQuery (query) {
    return decodeQuery(query);
  },
  stringifyQuery (query) {
    return encodeQuery(query);
  }
});

export default router
